import { MissionListItemProps } from "@/components/MissionList/MissionItem"
import style from "@/components/MissionList/MissionItem/style.scss"
import _ from "lodash"
import React from "react"
import MissionItemBody from "../../MissionItemBody"
import MissionItemHeader from "../../MissionItemHeader"
import MissionItemInstructions from "../../MissionItemInstructions"

const QuotaFull: React.SFC<Readonly<MissionListItemProps>> = (props) => {
  return (
    <>
      <MissionItemHeader mission={props.mission} />

      <div className={style.content}>
        <div className={style.description}>
          {props.mission.instructions && (
            <MissionItemInstructions
              openModal={props.openModal}
              index={props.index}
            />
          )}

          <MissionItemBody
            mission={props.mission}
            description={props.mission.description}
          />
        </div>
      </div>
    </>
  )
}

export default QuotaFull
